"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSearchbar = void 0;
const common_types_1 = require("../../common-types");
const peggy = __importStar(require("peggy"));
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const clsx_1 = __importDefault(require("clsx"));
const ClickAwayListener_1 = __importDefault(require("@material-ui/core/ClickAwayListener"));
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment/InputAdornment"));
const Popper_1 = __importDefault(require("@material-ui/core/Popper"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const Clear_1 = __importDefault(require("@material-ui/icons/Clear"));
const HelpOutline_1 = __importDefault(require("@material-ui/icons/HelpOutline"));
const Search_1 = __importDefault(require("@material-ui/icons/Search"));
const SettingsEthernet_1 = __importDefault(require("@material-ui/icons/SettingsEthernet"));
const evidence_defaults_context_1 = require("../evidence-defaults/evidence-defaults-context");
const tooltip_1 = require("../../components/tooltip/tooltip");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const filter_box_1 = require("./filter-box/filter-box");
const grammar_1 = require("./filter-box/grammar");
const utils_1 = require("./filter-box/utils");
const table_search_hook_1 = require("./hooks/table-search-hook");
const table_context_1 = require("./table-context");
const CHAR_SIZE = 8.4;
const METADATA_MATCH_QUERY = 'METADATA';
const HIGHLIGHT_MATCH_QUERY = 'HIGHLIGHT';
exports.TableSearchbar = (0, react_1.forwardRef)(function TableSearchbar(_, ref) {
    const { disabled, setSearchQuery, searchQuery, classes, columns, setAdvancedFilters, searchHighlight, setHighlights, } = (0, react_1.useContext)(table_context_1.TableContext);
    const { enableFilterBox } = (0, react_1.useContext)(evidence_defaults_context_1.EvidenceDefaultsContext);
    const [isFilterBox, setIsFilterBox] = (0, react_1.useState)(false);
    const highlightParser = (0, react_1.useRef)(peggy.generate(grammar_1.highlightGrammar));
    const [text, setText] = (0, react_1.useState)(searchQuery);
    const parser = (0, filter_box_1.useFilterParser)({
        columns,
        setFilters: setAdvancedFilters,
        isFilterBox,
        text,
        setText,
    });
    const intl = (0, react_intl_1.useIntl)();
    const handleClear = (0, event_callback_hook_1.useEventCallback)(() => {
        setText('');
        setSearchQuery('');
        setHighlights([]);
        setAdvancedFilters([]);
        parser.handleClear();
    });
    const handleToggleFilterBox = (0, event_callback_hook_1.useEventCallback)(() => {
        setSearchQuery('');
        setIsFilterBox((state) => !state);
    });
    const handleAdvancedSearch = (0, event_callback_hook_1.useEventCallback)(() => {
        if (!text) {
            handleClear();
            return;
        }
        const parsed = highlightParser.current.parse(text);
        const stringified = JSON.stringify(parsed);
        const advancedFilters = (0, utils_1.getAdvancedTextFilter)(stringified, searchHighlight);
        if (advancedFilters) {
            setSearchQuery('');
            setHighlights(searchHighlight);
            setAdvancedFilters([
                {
                    operation: common_types_1.ApiFilterOperation.OR,
                    filters: [
                        {
                            field: '',
                            operation: common_types_1.ApiFilterOperation.FTX,
                            value: text,
                            queryName: METADATA_MATCH_QUERY,
                            excludedFields: searchHighlight,
                        },
                        {
                            ...advancedFilters,
                            queryName: HIGHLIGHT_MATCH_QUERY,
                        },
                    ],
                },
            ]);
        }
    });
    const handleKeyDown = (0, event_callback_hook_1.useEventCallback)((e) => {
        if (isFilterBox) {
            parser.handleKeyDown(e);
        }
        else if (searchHighlight.length > 0 && e.key === 'Enter') {
            handleAdvancedSearch();
        }
        else {
            if (e.key === 'Enter') {
                e.preventDefault();
                setSearchQuery(text);
            }
        }
    });
    const handleInput = (0, event_callback_hook_1.useEventCallback)((e) => {
        if (isFilterBox) {
            parser.handleInput(e);
        }
        else {
            const target = e.target;
            setText(target.value);
        }
    });
    const handleClick = (0, event_callback_hook_1.useEventCallback)(() => {
        if (isFilterBox) {
            parser.handleSubmit();
        }
        else if (searchHighlight.length > 0) {
            handleAdvancedSearch();
        }
        else {
            setSearchQuery(text);
        }
    });
    (0, react_1.useImperativeHandle)(ref, () => ({
        setSearchText: setText,
    }), [setText]);
    const suggestionsPosition = parser.cursorPosition.current * CHAR_SIZE - parser.inputScrollOffset;
    const showSuggestions = suggestionsPosition <= parser.inputWidth && suggestionsPosition > 0;
    const { searchFilterBoxHelp, searchHighlightHelp } = (0, table_search_hook_1.useHelp)();
    return (react_1.default.createElement("div", { onKeyDown: handleKeyDown, onInput: handleInput, className: classes.searchBar, "data-cy": "EAS__SEARCHBAR" },
        react_1.default.createElement(TextField_1.default, { inputRef: parser.inputRef, disabled: disabled, classes: { root: classes.searchTextField }, autoComplete: "off", id: "outlined-search", type: "search", margin: "dense", placeholder: intl.formatMessage({
                id: 'EAS_TABLE_SEARCHBAR',
                defaultMessage: 'Vyhledat',
            }), variant: "outlined", value: text, multiline: false, error: parser.error, InputProps: {
                spellCheck: false,
                classes: {
                    root: classes.searchTextFieldInput,
                    input: classes.input,
                },
                startAdornment: parser.highlightedText,
                endAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "end" },
                    searchHighlight.length > 0 && !isFilterBox && (react_1.default.createElement(tooltip_1.Tooltip, { type: "CLICKABLE", title: searchHighlightHelp, placement: "top-start" },
                        react_1.default.createElement(HelpOutline_1.default, { classes: { root: classes.smallFilterIcon }, "data-cy": "EAS__SEARCHBAR__HELP" }))),
                    isFilterBox && (react_1.default.createElement(tooltip_1.Tooltip, { type: "CLICKABLE", title: searchFilterBoxHelp, placement: "top-start" },
                        react_1.default.createElement(HelpOutline_1.default, { classes: { root: classes.smallFilterIcon }, "data-cy": "EAS__SEARCHBAR__HELP" }))),
                    text && (react_1.default.createElement(tooltip_1.Tooltip, { title: intl.formatMessage({
                            id: 'EAS_TABLE_SEARCHBAR_BTN_CLEAR',
                            defaultMessage: 'Smazat text',
                        }), placement: "top-start" },
                        react_1.default.createElement(Clear_1.default, { classes: { root: classes.smallFilterIcon }, onClick: handleClear, "data-cy": "EAS__SEARCHBAR__CLEAR" }))),
                    enableFilterBox && (react_1.default.createElement(tooltip_1.Tooltip, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_SEARCHBAR_BTN_ADVANCED", defaultMessage: "Pokro\u010Dil\u00E9 hled\u00E1n\u00ED" }), placement: "top-start" },
                        react_1.default.createElement(SettingsEthernet_1.default, { classes: {
                                root: (0, clsx_1.default)({
                                    [classes.filterIcon]: !isFilterBox,
                                    [classes.activeFilterIcon]: isFilterBox,
                                }),
                            }, onClick: handleToggleFilterBox }))),
                    react_1.default.createElement(tooltip_1.Tooltip, { title: intl.formatMessage({
                            id: 'EAS_TABLE_SEARCHBAR_BTN_SEARCH',
                            defaultMessage: 'Hledat',
                        }), placement: "top-start" },
                        react_1.default.createElement(Search_1.default, { classes: { root: classes.searchIcon }, onClick: handleClick, "data-cy": "EAS__SEARCHBAR__SEARCH" })))),
                style: {
                    fontFamily: isFilterBox ? 'monospace' : 'inherit',
                },
            } }),
        !!parser.suggestions.length && parser.inputRef && showSuggestions && (react_1.default.createElement(Popper_1.default, { role: "presentation", anchorEl: parser.inputRef.current, placement: "bottom-start", open: true, style: {
                zIndex: 999,
            } },
            react_1.default.createElement(ClickAwayListener_1.default, { onClickAway: parser.clearSuggestions },
                react_1.default.createElement("ul", { ref: parser.listRef, className: classes.list, style: {
                        left: `calc(${parser.cursorPosition.current * CHAR_SIZE}px - ${parser.inputScrollOffset}px)`,
                    } }, parser.suggestions.map((suggestion) => (react_1.default.createElement("li", { tabIndex: 1, key: suggestion.key, className: classes.listItem }, suggestion.label)))))))));
});
//# sourceMappingURL=table-searchbar.js.map